(() => {
  const preview = new URLSearchParams(location.search).has('holylead_preview');
  const seen = new WeakSet();
  function record() {
    document.querySelectorAll('[role="dialog"][id^="holylead-"]').forEach(dialog => {
      if (seen.has(dialog) || !dialog.getClientRects().length) return;
      // The automatic CRM popup and the manually opened theme popup share this DOM.
      // Keep their accessibility equivalent without changing submission or eligibility.
      const labels = {ddi:'País e código telefônico',dia:'Dia de nascimento',mes:'Mês de nascimento',ano:'Ano de nascimento'};
      dialog.querySelectorAll('select[name]').forEach(select => {
        if (labels[select.name]) select.setAttribute('aria-label', labels[select.name]);
      });
      const column = dialog.querySelector('[data-holylead="form"]');
      if (column) {
        Array.from(column.children).filter(el => el.tagName === 'DIV').forEach(el => {
          if (el.querySelector('span')) el.style.color = '#205c3e';
          if (el.textContent.startsWith('Ao continuar')) { el.style.color = '#595959'; el.style.fontSize = '12px'; }
        });
      }
      const submit = dialog.querySelector('button[type="submit"]');
      if (submit) {
        const rgb = getComputedStyle(submit).backgroundColor.match(/[\d.]+/g);
        if (rgb && rgb.length >= 3) {
          const channels = rgb.slice(0,3).map(v => { v=Number(v)/255; return v<=.04045?v/12.92:Math.pow((v+.055)/1.055,2.4); });
          const light = channels[0]*.2126+channels[1]*.7152+channels[2]*.0722;
          submit.style.color = light>.179?'#000000':'#ffffff';
        }
      }
      const close = dialog.querySelector('button[aria-label="fechar"]');
      if (close) { close.style.width='44px'; close.style.height='44px'; }
      const slug = dialog.id.slice('holylead-'.length);
      if (!slug || slug.startsWith('canto-')) return;
      seen.add(dialog);
      if (!preview) try { localStorage.setItem('holylead_' + slug, String(Date.now())); } catch (_) {}
    });
  }
  const observer = new MutationObserver(record);
  observer.observe(document.body, {childList:true});
  record();
})();
